import { isNil } from 'lodash';
import moment from 'moment';

const dateLabel = [
  'DOB',
  'Start Date',
  'End Date',
  'Date of Joining',
  'Date Left',
  'Date of Birth',
  'Verification Date',
  'Match Date',
  'Start Date',
  'End Date',
];
// Convert dates properly
export const convertExcelDate = (excelDate: number) => {
  const jsDate = new Date((excelDate - 25569) * 86400 * 1000);
  const formattedDate = jsDate.toISOString().split('T')[0];
  return formattedDate.split('-').reverse().join('/');
};

export const renderSubmittedValue = (name: string, value: any) => {
  if (isNil(value)) {
    return '_';
  }

  if (dateLabel.includes(name)) {
    return convertExcelDate(value);
  }
  return value;
};

export const formatDateDisplay = (
  date: string | null | undefined | moment.Moment,
  showFallback = true,
  format = 'DD/MM/YYYY',
  fallbackValue = '_',
) => {
  if (!date) return showFallback ? fallbackValue : '';
  if (moment(date).isValid()) {
    return moment(date).format(format);
  }
  return showFallback ? fallbackValue : '';
};
